import { c as _c } from "react/compiler-runtime";
import SettingsLayout from 'modules/profile/components/settings-layout';
import { settingsMenuLocoKeys } from 'modules/profile/constants/settings-menu-loco-keys';
import { PaymentGatewaysLoco } from 'modules/profile/payment-gateways/constants/payment-gateways-loco';
import { PaymentGatewaysEnum } from 'modules/profile/payment-gateways/enums/payment-gateways';
import { CashOnDelivery } from 'modules/profile/payment-gateways/integrations/cash-on-delivery';
import { Flutterwave } from 'modules/profile/payment-gateways/integrations/flutterwave';
import { Gocardless } from 'modules/profile/payment-gateways/integrations/gocardless';
import { Mercadopago } from 'modules/profile/payment-gateways/integrations/mercadopago';
import { Mollie } from 'modules/profile/payment-gateways/integrations/mollie';
import { PaypalRest } from 'modules/profile/payment-gateways/integrations/paypal-rest';
import { usePaypalIntegrationType } from 'modules/profile/payment-gateways/integrations/paypal-rest/hooks/use-paypal-integration-type';
import { PaypalSoap } from 'modules/profile/payment-gateways/integrations/paypal-soap';
import { Paystack } from 'modules/profile/payment-gateways/integrations/paystack';
import { Razorpay } from 'modules/profile/payment-gateways/integrations/razorpay';
import { SecureAndPay } from 'modules/profile/payment-gateways/integrations/secure-and-pay';
import { Stripe } from 'modules/profile/payment-gateways/integrations/stripe';
import { Xendit } from 'modules/profile/payment-gateways/integrations/xendit';
import { NextPage } from 'next';
import React, { type JSX, useMemo } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations';
import { PaystackPaymentIntegrationInterface } from 'modules/profile/payment-gateways/integrations/paystack/types';
import { paystackPaymentProcessors } from 'modules/profile/payment-gateways/integrations/paystack/constants';
const PaymentGateways: NextPage = () => {
  const $ = _c(17);
  const {
    t
  } = useLocoTranslation();
  const getPaymentIntegration = _temp;
  const {
    shouldShowRest,
    shouldShowSoap
  } = usePaypalIntegrationType();
  const {
    getConnectedPaymentIntegration
  } = useConnectedPaymentIntegrations();
  const paystackIntegration = getConnectedPaymentIntegration({
    matcher: _temp2
  });
  let t0;
  bb0: {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = Object.values(PaymentGatewaysEnum);
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let initialPaymentGateways = t1;
    if (!paystackIntegration) {
      let t2;
      if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = initialPaymentGateways.filter(_temp3);
        $[1] = t2;
      } else {
        t2 = $[1];
      }
      initialPaymentGateways = t2;
    }
    if (shouldShowRest && shouldShowSoap) {
      t0 = initialPaymentGateways;
      break bb0;
    }
    if (shouldShowRest) {
      let t2;
      if ($[2] !== initialPaymentGateways) {
        t2 = initialPaymentGateways.filter(_temp4);
        $[2] = initialPaymentGateways;
        $[3] = t2;
      } else {
        t2 = $[3];
      }
      t0 = t2;
      break bb0;
    }
    if (shouldShowSoap) {
      let t2;
      if ($[4] !== initialPaymentGateways) {
        t2 = initialPaymentGateways.filter(_temp5);
        $[4] = initialPaymentGateways;
        $[5] = t2;
      } else {
        t2 = $[5];
      }
      t0 = t2;
      break bb0;
    }
    let t2;
    if ($[6] !== initialPaymentGateways) {
      t2 = initialPaymentGateways.filter(_temp6);
      $[6] = initialPaymentGateways;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    t0 = t2;
  }
  const paymentGateways = t0;
  let t1;
  if ($[8] !== t) {
    t1 = t(settingsMenuLocoKeys.payment_gateways);
    $[8] = t;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  let t2;
  if ($[10] !== t1) {
    t2 = [{
      caption: t1,
      isStatic: true
    }];
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== paymentGateways) {
    t3 = <div className="bg-background-secondary flex h-fit w-full justify-center overflow-x-hidden rounded-md lg:justify-start lg:px-8 lg:py-3"><div className="[&>*]:flex-1 flex w-full flex-col justify-center">{paymentGateways.map((el, idx) => <React.Fragment key={el}><div className="flex w-full flex-col px-6 py-12 lg:px-0 lg:py-8">{getPaymentIntegration(el)}</div>{idx !== paymentGateways.length - 1 && <hr className="text-text-secondary/30" />}</React.Fragment>)}</div></div>;
    $[12] = paymentGateways;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== t2 || $[15] !== t3) {
    t4 = <SettingsLayout titles={t2} needSave={false}>{t3}</SettingsLayout>;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
};
export const getServerSideProps = getBaseServerSideProps(PaymentGatewaysLoco, 'global.settings');
export default PaymentGateways;
function _temp(payment) {
  switch (payment) {
    case PaymentGatewaysEnum.CashOnDelivery:
      {
        return <CashOnDelivery />;
      }
    case PaymentGatewaysEnum.Flutterwave:
      {
        return <Flutterwave />;
      }
    case PaymentGatewaysEnum.Gocardless:
      {
        return <Gocardless />;
      }
    case PaymentGatewaysEnum.MercadoPago:
      {
        return <Mercadopago />;
      }
    case PaymentGatewaysEnum.Mollie:
      {
        return <Mollie />;
      }
    case PaymentGatewaysEnum.PaypalRest:
      {
        return <PaypalRest />;
      }
    case PaymentGatewaysEnum.PaypalSoap:
      {
        return <PaypalSoap />;
      }
    case PaymentGatewaysEnum.Paystack:
      {
        return <Paystack />;
      }
    case PaymentGatewaysEnum.Razorpay:
      {
        return <Razorpay />;
      }
    case PaymentGatewaysEnum.SecureAndPay:
      {
        return <SecureAndPay />;
      }
    case PaymentGatewaysEnum.Stripe:
      {
        return <Stripe />;
      }
    case PaymentGatewaysEnum.Xendit:
      {
        return <Xendit />;
      }
  }
}
function _temp2(paymentProcessor) {
  return paystackPaymentProcessors.includes(paymentProcessor);
}
function _temp3(pg) {
  return pg !== PaymentGatewaysEnum.Paystack;
}
function _temp4(pg_0) {
  return pg_0 !== PaymentGatewaysEnum.PaypalSoap;
}
function _temp5(pg_1) {
  return pg_1 !== PaymentGatewaysEnum.PaypalRest;
}
function _temp6(pg_2) {
  return pg_2 !== PaymentGatewaysEnum.PaypalRest && pg_2 !== PaymentGatewaysEnum.PaypalSoap;
}